<template>
  <div class="viewer-image">
    <img class="viewer-image__image" :src="getUrl(src)" :alt="decodeURI(alt)" />
  </div>
</template>

<script>
import { queryAssembler } from '@/mixins/queryAssembler';
export default {
  mixins: [queryAssembler],
  props: {
    src: {
      type: String,
    },
    alt: {
      type: String,
      default: 'Alt image description',
    },
  },
  methods: {
    getUrl(src) {
      return this.assembleUrl(src);
    },
  },
};
</script>

<style scoped>
.viewer-image {
  height: 100vh;
  position: relative;
  width: 100vw;
}
.viewer-image__image {
  height: 100%;
  object-fit: cover;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ViewerImage.vue